module.exports = __webpack_public_path__ + "img/Haefele_menu10.15a679aa.png";